import styled from 'styled-components';

import Button from 'components/shared/Button';
import CircularProgress from 'components/shared/CircularProgress';
import useAsyncExport from 'hooks/useAsyncExport';
import { capitalize } from 'lib/util';
import { createAIArtifactExport } from 'services/api/aiArtifacts';
import colors from 'styles/theme/colors';

type DownloadAIExportButtonProps = {
  artifactId: string;
  artifactType: 'summary' | 'comparison';
};

export function DownloadAIExportButton({ artifactId, artifactType }: DownloadAIExportButtonProps) {
  const { exporting, initiateExport } = useAsyncExport(createAIArtifactExport);
  const artifactTypeCapitalized = capitalize(artifactType);

  return (
    <StyledButton
      variant='outline-primary'
      data-cy={`download${artifactTypeCapitalized}`}
      onClick={() => initiateExport(artifactId)}
      disabled={exporting}>
      <span style={{ opacity: exporting ? 0 : 1 }}>Download {artifactTypeCapitalized}</span>
      {exporting && (
        <SpinnerContainer>
          <ExportLoadingIndicator thickness={2} />
        </SpinnerContainer>
      )}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  font-size: 12px;
  letter-spacing: 0.2px;
  padding: 8px 16px;
  position: relative;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ExportLoadingIndicator = styled(CircularProgress)`
  width: 18px;
  height: 18px;
  color: ${colors.primaryBlue};
`;
